<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/chanp/productSourcing',title:'自产产品货源动态日报表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
				<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
					<div class="h-formBox w-formBox one-formBox">
						<el-form-item label="生产日期">
							<el-date-picker
									:clearable="true"
									v-model="formInline.productionTime"
									type="date"
									value-format="yyyy-MM-dd"
									placeholder="--日期--"
									style="width:100%">
							</el-date-picker>
						</el-form-item>
						<el-form-item class="right-btn">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置 </el-button>
						</el-form-item>
					</div>
				</el-form>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            :span-method="objectSpanMethod"
                            stripe
							max-height="480"
                            style="width: 100%">
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                label="#"
								fixed
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proType"
                                width="100"
                                label="系列"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="product_level" :v="scope.row.proType"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proModel"
                                min-width="180"
                                label="产品型号"
                                :show-overflow-tooltip="true">
								<template slot-scope="scope">
								    <div style="text-align: left;">{{scope.row.proModel}}</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                width="100"
                                label="产品编码"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column label="库存" :show-overflow-tooltip="true">
                            <el-table-column
                                    prop="stock"
                                    label="账面库存"
                                    width="100"
                                    :show-overflow-tooltip="true">
										<template slot-scope="scope">
										    <div style="text-align: right;">{{scope.row.stock}}</div>
										</template>
                            </el-table-column>
                            <el-table-column
                                    prop="toBeShipped"
                                    width="160"
                                    label="已审未发货过帐数"
                                    :show-overflow-tooltip="true">
									<template slot-scope="scope">
									    <div style="text-align: right;">{{scope.row.toBeShipped}}</div>
									</template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                                prop="availableStock"
                                width="90"
                                label="可用库存"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname style="text-align: left;" category="YLRegion" :v="scope.row.area"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="toBeAudited"
                                width="140"
                                label="系统待审核订单"
                                :show-overflow-tooltip="true">
								<template slot-scope="scope">
								    <div style="text-align: right;">{{scope.row.toBeAudited}}</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="sourceValue"
                                width="90"
                                label="货源差"
                                :show-overflow-tooltip="true">
								<template slot-scope="scope">
								    <div style="text-align: right;">{{scope.row.sourceValue}}</div>
								</template>
                        </el-table-column>
                        <el-table-column label="已锁定生产计划待下线" :show-overflow-tooltip="true">
                            <el-table-column
                                    prop="productionCycle"
                                    width="120"
                                    label="生产周期"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="productionTime"
                                    width="120"
                                    label="生产日期"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="planNum"
                                    width="90"
                                    label="计划数量"
                                    :show-overflow-tooltip="true">
									<template slot-scope="scope">
									    <div style="text-align: right;">{{scope.row.planNum}}</div>
									</template>
                            </el-table-column>
                            <el-table-column
                                    prop="finishNum"
                                    width="90"
                                    label="完成数量"
                                    :show-overflow-tooltip="true">
									<template slot-scope="scope">
									    <div style="text-align: right;">{{scope.row.finishNum}}</div>
									</template>
                            </el-table-column>
                            <el-table-column
                                    prop="difference"
                                    width="90"
                                    label="差异"
                                    :show-overflow-tooltip="true">
									<template slot-scope="scope">
									    <div style="text-align: right;">{{scope.row.difference}}</div>
									</template>
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-tableB h-mrt30" style="padding-right: 0.12rem;">
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="handleList"/>
                </div>
            </div>
        </div>
        <!--<div class="h-txtCenter h-mrt60" style="margin: 1rem auto 0 auto;">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="renovate">返回</el-button>
        </div>-->
    </div>
</template>
<script>

    import ss from '../../api/SystemService';

    export default {
        data() {
            return {
                formInline: {
                    productionTime: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                tableData: [],
                spanArr: [],
            }
        },
        mounted() {

        },
        created() {
            this.query();
        },
        methods: {
            getSpanArr() {
                this.spanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].proCode === this.tableData[index - 1].proCode) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (column.label == '系列' || column.label == '产品型号' || column.label == '产品编码') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
                if (column.label == '账面库存' || column.label == '已审未发货过帐数' || column.label == '可用库存') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
                if (column.label == '系统待审核订单' || column.label == '货源差' || column.label == '生产周期') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },
            query() {
                ss.loud.selectReportPage(this.formInline).then(rd => {
                    this.tableData = rd.records;
                    this.formInline.total = rd.total;
                    this.getSpanArr();
                })
            },
            handleFilter() {
                this.formInline.pageNo = 1;
                ss.loud.selectReportPage(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                    this.getSpanArr();
                })
            },
            handleList() {
                ss.loud.selectReportPage(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                    this.getSpanArr();
                })
            },
            resetData() {
                this.formInline.productionTime = '';
                this.formInline.pageSize = 10,
                this.query();
            },
            renovate() {
                this.resetData();
            }
        }
    }
</script>
<style>
    .smTable .el-table tbody td .cell {
        padding-top: 0;
        padding-bottom: 0;
    }

    .el-table thead.is-group th {
        background-color: #57aefe;
    }
</style>